import { gridOptions } from "../../utils/globalOptions";

const totalSegmentedPeopleConfig = (dataArray) => {
  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false,
      labels: {
        padding: 50,
      },
    },
  };

  const barPercentage = 0.7;

  const colors = [
    {
      backgroundColor: "rgba(126,87,194,1)",
      borderColor: "#7E57C2",
      pointBackgroundColor: "#3f51b5",
      pointBorderColor: "#fff",
      hoverBackgroundColor: "#3B1087",
    },
    {
      backgroundColor: "rgba(3,169,244,1)",
      borderColor: "#03A9F4",
      pointBackgroundColor: "#007AB1",
      pointBorderColor: "#fff",
      hoverBackgroundColor: "#007AB1",
    },
    {
      backgroundColor: "rgba(240,154,172,1)",
      borderColor: "#F09AAC",
      pointBackgroundColor: "#E3274E",
      pointBorderColor: "#fff",
      hoverBackgroundColor: "#E3274E",
    },
  ];

  const labels = [
    "San José",
    "Alajuela",
    "Cartago",
    "Heredia",
    "Guanacaste",
    "Puntarenas",
    "Limón",
  ];
  const datasets = [
    {
      label: "Personas Adultas Mayores",
      ...colors[0],
      borderWidth: 1,
      data: dataArray[0],
      barPercentage,
    },
    {
      label: "Personas Jóvenes y Adultos",
      ...colors[1],
      borderWidth: 1,
      data:  dataArray[1],
      barPercentage,
    },
    {
      label: "Niños y Niñas",
      ...colors[2],
      borderWidth: 1,
      data:  dataArray[2],
      barPercentage,
    },
  ];

  const data = {
    labels,
    datasets,
  };

  return {
    type: "horizontalbar",
    title: "Total de personas evacuadas",
    subtitle:
      "Personas adultas mayores, jóvenes y adultos y niños y niñas distribuidos por provincia",
    data,
    options: {
      ...sharedOptions,
      ...gridOptions,
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          display: false,
        },
      },
    },
  };
};

export default totalSegmentedPeopleConfig;
